<template>
  <el-pagination
    v-bind="$attrs"
    :total="total"
    background
    :layout="layout"
    :page-sizes="pageSizes"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'pagination',
  props: {
    pageSizes: {
      type: Array as PropType<number[]>,
      default: () => {
        return [10, 20, 50];
      },
    },

    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },

    total: {
      type: Number,
      default: 0,
    },
  },
});
</script>
